import { createContext, useContext } from 'react';

export type WhatsAppAccountsContextState = {
  whatsAppAccounts: any;
  isLoadingWhatsAppAccounts: boolean;
};

const defaultState = {
  whatsAppAccounts: {},
  isLoadingWhatsAppAccounts: false,
};

export const WhatsAppAccountsQueryContext =
  createContext<WhatsAppAccountsContextState>(defaultState);

export const useWhatsAppAccountsContext = () => {
  const { isLoadingWhatsAppAccounts, whatsAppAccounts } = useContext(WhatsAppAccountsQueryContext);

  return {
    whatsAppAccounts,
    isLoadingWhatsAppAccounts,
  };
};
